import axios from 'axios';

// Create axios instance for public endpoints
const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api`
});

// Get all public categories for navbar
export const getPublicCategories = async () => {
  try {
    const response = await API.get('/categories');
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.message || 'Failed to fetch categories';
  }
};

// Get products with filtering options
export const getProducts = async (params = {}) => {
  try {
    const response = await API.get('/products', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.message || 'Failed to fetch products';
  }
};

// Get single product by slug
export const getProductBySlug = async (slug) => {
  try {
    const response = await API.get(`/products/${slug}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.message || 'Failed to fetch product';
  }
};

// Get size chart for a product
export const getProductSizeChart = async (slug) => {
  try {
    const response = await API.get(`/products/${slug}/size-chart`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.message || 'Failed to fetch size chart';
  }
};

// Get public settings
export const getSettings = async () => {
  try {
    const response = await API.get('/settings');
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.message || 'Failed to fetch settings';
  }
};

// Get top users for leaderboard
export const getLeaderboard = async (limit = 5) => {
  try {
    const response = await API.get('/leaderboard', { params: { limit } });
    return response.data;
  } catch (error) {
    throw error.response?.data?.error || error.message || 'Failed to fetch leaderboard';
  }
};
